module.exports = __webpack_public_path__ + "img/bx_error.eec04f6e.svg";